"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("@mui/material/utils");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports["default"] = (0, _utils.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: 'M19 13C21.76 13 24 15.24 24 18C24 20.76 21.76 23 19 23C16.24 23 14 20.76 14 18C14 15.24 16.24 13 19 13ZM19.5 15H18.5V18.2L20.65 20.35L21.35 19.64L19.5 17.79V15ZM20 4C21.1 4 22 4.9 22 6V11.6736C21.3783 11.3783 20.7061 11.1719 20 11.0709V8L12 13L4 8V18H12C12 18.695 12.1013 19.3663 12.2899 20H4C2.9 20 2 19.1 2 18L2.01 6C2.01 4.9 2.9 4 4 4H20ZM20 6H4L12 11L20 6Z'
}), 'MailClockOutlineIcon');